<template>
  <div id="container">
    <el-link
      id="head"
      :underline="false"
      type="primary"
      target="_blank"
      href="https://mp.weixin.qq.com/s/Qb3tKc3sTX0GfA3Bb4g9uw?"
    >鲤鱼门家族®</el-link>
    <p>
      鲤鱼门(深圳)投资管理有限公司-中国证券投资基金业协会备案编号P1032768
      <br />注册地址:广东省深圳市前海深港合作区前湾一路1号A栋201室
    </p>
    <div id='line'/>
    <div id="content">
      <div id="leftlinks">
        <ul>
          <li>
            <el-link
              id="link"
              :underline="false"
              href="http://gs.amac.org.cn/amac-infodisc/res/pof/fund/351000505786.html"
              target="_blank"
            >鲤鱼门家族私募证券投资基金公示信息</el-link>
            <div>（链接至中国基金业协会私募基金公示网页，接受社会公示）</div>
          </li>
          <li>
            <el-link :underline="false" href="http://dc.simuwang.com/product/HF000024HP.html" target="_blank">鲤鱼门家族业绩</el-link>
            <div>（链接至第三方业绩展示平台，搜索“鲤鱼门家族”，须通过合格投资者认证方可查看）</div>
          </li>
          <li>
            <el-link :underline="false" href="https://tgjj.newone.com.cn/login/index" target="_blank">投资者服务平台</el-link>
            <div>（链接至托管商&外包服务商招商证券，针对已认购基金产品投资者）</div>
          </li>
        </ul>
      </div>
      <div id="rightlinks">
        <div style="color:#020c73;margin-left:20px">相关链接</div>
        <ul>
          <li>
            <el-link :underline="false" href="http://www.amac.org.cn" target="_blank">中国基金业协会官网</el-link>
          </li>
          <li>
            <el-link :underline="false" href="https://www.simuwang.com/aboutus/certificate.html" target="_blank">第三方资质证书</el-link>
          </li>
          <li>
            <el-link :underline="false" href="http://www.csrc.gov.cn/pub/zjhpublic/G00306208/201402/t20140218_243982.htm" target="_blank">招商证券私募证券投资基金托管资质</el-link>
          </li>
          <li>
            <el-link :underline="false" href="http://fo.amac.org.cn/amac/allNotice.do" target="_blank">招商证券私募证券基金外包服务资质</el-link>
          </li>
          <li>
            <el-link  :underline="false" href="http://wcjs.sbj.cnipa.gov.cn/txnDetail.do?request:tid=TID201807442449DABB81176C5CBA0B282AC8B12D73B36&request:index=1&kmcmNx0Q=qAqQqqrzMKTzMKTzMRL_JPDhb3o0W4lasrZ77xJfLt0qqD0" target="_blank" >鲤鱼门家族基金商标</el-link>
          </li>
          <li>
            <el-link :underline="false" href="http://wcjs.sbj.cnipa.gov.cn/txnDetail.do?Flt3WMZ5=qqrK10lmvm7Hstk7I2XPk_yTgoJ_BfYysUdN7zfBjcslbVl9gFaIPYY215ieplQC6kY7VupgWm62EC4XOLUka55c8Q1IQ66pbMapMYM72QYM3WDUr6yeUsN8A9QjoZDePq9em1TSeD9OTUM1xuyf058nGcZ&wfAbSsA0=2FkxhKkc2zScUC6nJ6P_W25SLhZetxf.mkDkLX5iGRvOr1iX596PRKvc8B0vdXbzvWaFH24448K4iiF4OAFEdkWEfYBHBuzhykxDuoDqRRIAJDbwxwiOZMe0pBOdD.CcSI_c9Sr2vNjMBZ3xWwwqny301Lr2d579cv.SBdFx3DSPeLWttxafgTN1kTXKx0kerYGrQCAvOfvJyND1PfdNoyLwvooj6l3bamnTQfL_xIbg" target="_blank">鲤鱼门公司商标</el-link>
          </li>
        </ul>
      </div>
    </div>
    <div style="margin-top:40px;margin-bottom:40px;color:#020c73">鱼跃龙门，过而为龙</div>
    <div id='line'/>
    <div id="tip"
    >友情提示：“鲤鱼门家族”网站，仅作为公司理念及基本信息的展示平台，公司所发行“鲤鱼门家族”基金产品信息为中国基金业协会许可公示信息，产品业绩须通过私募基金合格投资者认证方能从第三方机构私募排排网获取。本网页，不发生任何线上交流互动及线上交易，提请网站使用者注意。
    </div>
    <div id='line'/>
    <div id="about">
      <el-link
        type="primary"
        href="https://mp.weixin.qq.com/s/BXRl0n1VBw7SEbM0GooKsw?"
        target="_blank"
      >联系我们</el-link>
      <br />
      <el-link
        type="primary"
        href="https://mp.weixin.qq.com/s/UXnNQJJybVz4N9AEcCP0Fg?"
        target="_blank"
      >关于我们</el-link>
       <div id='line'/>
    </div>
     <div id='line'/>
    <div style="margin-top:40px" >
      <el-link style="color:blue" :underline="false" target="_blank" href="http://www.miit.gov.cn/">粤ICP备16112655</el-link>
    </div>
    
    <el-dialog title="特定合格投资者认定" :visible.sync="dialogVisible" :show-close="false" width="70%" center>
      <div >
        <p style="color:black">私募基金投资是一种高净值财富投入的金融投资行为，需要投资者具备足够的经济实力和抗风险素质，为了节省阁下时间，请比照中国基金业协会《私募投资基金募集行为管理办法》第三章第十二条对合格投资者的认定。</p>
        <p style="color:black">私募基金的合格投资者是指具备相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100万元且符合下列相关标准的单位和个人：</p>
        <p style="color:black">（一）净资产不低于1000万元的单位；</p>
        <p style="color:black">（二）金融资产不低于300万元或者最近三年个人年均收入不低于50万元的个人。</p>
        <p style="color:black">前款所称金融资产包括银行存款、股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货权益等。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">我已阅读，进入主页</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "Home",
   title: '内容',
  data() {
    return {
      dialogVisible: true
    };
  }
};
</script>
<style  scoped>
#container {
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 40px;
}
#container p{
  color: #020c73;
  font-size: 20px;
}
#head {
  font-size: 30px;
  color: #020c73;
}
#content {
  display: flex;
   margin-top: 20px;
}
#leftlinks {
  padding-left: 100px;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
#leftlinks .el-link {
  color: #020c73;
  font-size: 18px;
}

#rightlinks {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
 
}
#rightlinks .el-link {
  color: #020c73;
  font-size: 13px;
}
#rightlinks li {
 text-align: left;
 
}
#leftlinks li{
   text-align: left;
   margin-top: 10px;
   margin-bottom: 10px;
}
#leftlinks div{
  font-size: 10px;
  color: #020c73;
}

/* p {
  font-size: 15px;
} */
#about {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 40px;
  margin-bottom: 40px;
}
#about .el-link{
  color: #020c73;
}
#tip {
  margin-top: 20px;
  margin-bottom: 20px;
  color: #020c73;
  text-align: left;
  font-size: 15px;
}
#line {
  background-color: #020c73;
  height: 1px;
}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue